"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRefresher = void 0;
var utils_1 = require("./utils");
var TokenRefresher = /** @class */ (function () {
    function TokenRefresher(onRefresh) {
        this.onRefresh = onRefresh;
        this.refreshInterval = null;
        this.errors = 0;
        this.refreshInFlight = false;
    }
    TokenRefresher.prototype.getCurrentErrorCount = function () {
        return this.errors;
    };
    Object.defineProperty(TokenRefresher.prototype, "timeFromLastRefreshAttempt", {
        get: function () {
            return this.lastRefreshTimeInSeconds !== undefined ? (0, utils_1.getTimestamp)() - this.lastRefreshTimeInSeconds : undefined;
        },
        enumerable: false,
        configurable: true
    });
    TokenRefresher.prototype.refreshImmediately = function () {
        this.triggerRefresh().catch();
    };
    TokenRefresher.prototype.refreshDeadlineInSeconds = function (seconds) {
        this.errors = 0;
        this.scheduleRefresh(seconds);
    };
    TokenRefresher.prototype.cancel = function () {
        if (this.refreshInterval) {
            clearTimeout(Number(this.refreshInterval));
            this.refreshInterval = null;
        }
    };
    TokenRefresher.prototype.triggerRefresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.refreshInFlight) return [3 /*break*/, 5];
                        this.refreshInFlight = true;
                        this.lastRefreshTimeInSeconds = (0, utils_1.getTimestamp)();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.cancel();
                        return [4 /*yield*/, this.onRefresh()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.errors += 1;
                        // Adding a bit backoff for every error
                        this.scheduleRefresh(Math.min(this.errors * 2, 10));
                        return [3 /*break*/, 5];
                    case 4:
                        this.lastRefreshTimeInSeconds = (0, utils_1.getTimestamp)();
                        this.refreshInFlight = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TokenRefresher.prototype.scheduleRefresh = function (seconds) {
        var _this = this;
        // We don't allow an immediate refresh and the minimum time between refresh attempts is 1 second
        this.cancel();
        this.refreshInterval = setTimeout(function () { return _this.triggerRefresh(); }, (seconds > 0 ? seconds : 1) * 1000);
    };
    return TokenRefresher;
}());
exports.TokenRefresher = TokenRefresher;
